/* tslint:disable */
import * as React from 'react'

import { CmsContentsContainer } from '../organisms/Contents/CmsContentsContainer'
import { MenuPage } from './MenuPage'

export class CmsContentsPage extends MenuPage {
  renderContent () {
    return <CmsContentsContainer />
  }
}



// WEBPACK FOOTER //
// ./src/pages/CmsContentsPage.js